var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_vm.isPersonalProject ? _c('p', {
    class: _vm.$style.template
  }, [_c('base-icon', {
    directives: [{
      name: "m-r",
      rawName: "v-m-r",
      value: 5,
      expression: "5"
    }],
    attrs: {
      "size": 16,
      "name": "shopping_coupon"
    }
  }), _c('span', {
    class: _vm.$style.link,
    on: {
      "click": _vm.handleTemplateEditing
    }
  }, [_c('span', {
    directives: [{
      name: "text-decoration",
      rawName: "v-text-decoration:underline",
      arg: "underline"
    }]
  }, [_vm._v(_vm._s(_vm.$t('bill.ticket.blank')))]), _c('base-icon', {
    directives: [{
      name: "m-l",
      rawName: "v-m-l",
      value: 5,
      expression: "5"
    }],
    attrs: {
      "size": 16,
      "name": "basic_pen-create"
    }
  })], 1)], 1) : _vm._e(), _vm.transaction.multiBill ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.displaySalesProgress)
    }
  }) : _vm._e(), _vm.arrangement.countPerPayment ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayLimitForPerson)
    }
  }) : _vm._e(), _vm.arrangement.countBundle ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayCountPerPayment)
    }
  }) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }